import jwt from 'jsonwebtoken';
import { getRefreshToken } from '../utils/getRefreshToken';
const LS_KEY_NAME_USER = "scrappyuser";
const LS_LANG_NAME = "BLLANG";
const LS_DEEPLINK_PATH = "deeplink";

export const persistUser = (user) => {
  sessionStorage.setItem(LS_KEY_NAME_USER, JSON.stringify(user));
};

export const persistLanguage = lang => {
  localStorage.setItem(LS_LANG_NAME, lang);
}
export const getLanguage = () => {
  return localStorage.getItem(LS_LANG_NAME) || "en";
}

export const persistDeeplink = path => {
  localStorage.setItem(LS_DEEPLINK_PATH, path);
}

export const getDeeplink = () => {
  return localStorage.getItem(LS_DEEPLINK_PATH) || false;
}

export const clearDeeplink = () => {
  localStorage.removeItem(LS_DEEPLINK_PATH);
};

export const hasData = () => {
  return !!sessionStorage.getItem(LS_KEY_NAME_USER);
};

export const getUserData = () => {
  return JSON.parse(sessionStorage.getItem(LS_KEY_NAME_USER));
};

export const clearData = () => {
  sessionStorage.removeItem(LS_KEY_NAME_USER);
};

export const getToken = async () => {
  const userData = getUserData();
  if (userData && userData!==null && !isExpired(userData.token)) {
    return userData.token;
  } else if(userData && userData!==null && userData.refresh_token){
    return await getRefreshToken(userData.refresh_token);
  }
  else return null;
};

export const isExpired = (token) => {
  const decoded = jwt.decode(token);
  return decoded.exp * 1000 < Date.now();
};

export const clearLocalStorage = () => {
  localStorage.clear()
  sessionStorage.clear()
}